import { Injectable } from '@angular/core';

import { select, Store, Action } from '@ngrx/store';

import * as fromAppointment from './appointment.reducer';
import * as AppointmentSelectors from './appointment.selectors';
import * as AppointmentActions from './appointment.actions';
import {
  CreateAppointmentDto,
  IAppointment,
  UpdateAppointmentDTO
} from '@care-portals/api-interfaces';

@Injectable()
export class AppointmentFacade {
  isInitialized$ = this.store.pipe(select(AppointmentSelectors.getInitialized));
  loading$ = this.store.pipe(
    select(AppointmentSelectors.getAppointmentLoading)
  );
  crating$ = this.store.pipe(
    select(AppointmentSelectors.getAppointmentCreating)
  );
  updating$ = this.store.pipe(
    select(AppointmentSelectors.getAppointmentUpdating)
  );
  pulling$ = this.store.pipe(
    select(AppointmentSelectors.getAppointmentPulling)
  );
  allAppointment$ = this.store.pipe(
    select(AppointmentSelectors.getAllAppointment)
  );
  selectedAppointment$ = this.store.pipe(
    select(AppointmentSelectors.getSelected)
  );
  appointments$ = this.store.pipe(
    select(AppointmentSelectors.getAppointmentEntities)
  );

  waiting = false;
  isInitialized: boolean;
  filters: any;

  constructor(private store: Store<fromAppointment.AppointmentPartialState>) {
    // this.isInitialized$.subscribe(res => {
    //   this.isInitialized = res;
    //   if (this.isInitialized && this.waiting) {
    //     this.loadAppointments(this.filters);
    //   }
    // });
  }

  dispatch(action: Action) {
    this.store.dispatch(action);
  }
  getAppointmentById(id: string) {
    this.dispatch(AppointmentActions.getAppointmentById({ id }));
  }
  loadAppointments(filters: any) {
    if (!this.isInitialized) {
      this.waiting = true;
      this.filters = filters;
      // this.store.dispatch(AppointmentActions.stitchInit());
      this.dispatch(AppointmentActions.loadAppointments({ filters }));
    } else {
      this.waiting = false;
      this.dispatch(AppointmentActions.loadAppointments({ filters }));
    }
  }

  saveAppointmentSuccess(appointment: IAppointment) {
    this.dispatch(AppointmentActions.saveAppointmentSuccess({ appointment }));
  }

  createAppointment(appointment: CreateAppointmentDto) {
    this.dispatch(AppointmentActions.createAppointment({ appointment }));
  }

  updateAppointment(id: string, appointment: UpdateAppointmentDTO) {
    this.dispatch(AppointmentActions.updateAppointment({ id, appointment }));
  }

  updateAppointmentSuccess(appointment: IAppointment) {
    this.dispatch(AppointmentActions.updateAppointmentSuccess({ appointment }));
  }

  fetchMySeenTodayAppointments() {
    this.dispatch(AppointmentActions.fetchMySeenTodayAppointments());
  }

  pullAppointment() {
    this.dispatch(AppointmentActions.pullAppointment());
  }

  clearAppointment() {
    this.dispatch(AppointmentActions.clearAppointment());
  }
}
